<template>
  <Layout footer>
    <div class="app-container text-base">
      <div class="flex items-center py-5 text-base border-b border-gray-300" style="background-color: #faf9f9">
        <span class="mr-1">当前位置：</span>
        <NBreadcrumb>
          <NBreadcrumbItem @click="gotoHome">首页</NBreadcrumbItem>
          <NBreadcrumbItem>后续服务</NBreadcrumbItem>
        </NBreadcrumb>
      </div>
      <img class="carousel-img" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/banner8.png" />
      <div style="text-indent: 2em" class="zhu_yi flex items-center my-4">
        <img src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/news.png" alt="" />
        <span class="mx-2 text-base font-bold">注意事项：</span>
        <span style="color: #f70707">
          请学员登录“智慧人才”App，选择创孵进行技术咨询、政策咨询、成功经验展示、项目合作、导师跟踪辅导、投诉、意见反馈、服务评价、服务监督等。
        </span>
      </div>
      <div class="mt-14">
        <p>
          “青桔创孵”后续服务平台以用户体验为核心，力求为学员与导师搭建服务桥梁，打通培训最后一公里，提供从培训
          到辅导、从辅导到就业创业，从就业创业到资源对接，从资源对接到企业成长，伴随学员终身的闭环服务，形成更完善
          的后续服务支持。
        </p>
        <p class="mt-4">
          为学员提供孵化、项目展示、岗位对接及资源对接等功能,帮助学员解决就业创业过程中遇到的难题，提高就业创
          业成功率。
        </p>
      </div>
      <img class="w-full mx-auto mt-20" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/line8.png" />
      <img class="w-10/12 mx-auto mt-14"
        src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/content8-1.png" />
    </div>
  </Layout>
</template>

<script setup>
import Layout from '@/components/Layout';
import { useRouter } from 'vue-router';

const router = useRouter();
function gotoHome () {
  router.push('/');
}
</script>

<style lang="scss" scoped>
.carousel-img {
  display: block;
  width: 100%;
  height: 410px;
  object-fit: cover;
}

.zhu_yi {
  border: 1px dashed #f39a1d;
  height: 60px;
  font-size: 17px;
}
</style>
